import Vue from 'vue'
import Router from 'vue-router'
import jd from '@/components/jd'
import lz from '@/components/lz'
import dayung from '@/components/dayung'
import beauty from '@/components/beauty'
import eilis from '@/components/eilis'
import jdHome from '@/components/jdHome'
import jdRecommend from '@/components/jdRecommend'
import beautyHome from '@/components/beautyHome'
import beautyRecommend from '@/components/beautyRecommend'
import parklane from '@/components/parklane'
import june1 from '@/components/june1'
import funsiamo from '@/components/funsiamo'
import sosi from '@/components/sosi'
import ilovemilk from '@/components/ilovemilk'
import dybossMGMHome from '@/components/dybossMGMHome'
import dybossRecommend from '@/components/dybossRecommend'
import dybossRecRecommend from '@/components/dybossRecRecommend'
import markMGMHome from '@/components/markMGMHome'
import markRecommend from '@/components/markRecommend'
import markRecRecommend from '@/components/markRecRecommend'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/ilovemilk',
      name: 'ilovemilk',
      component: ilovemilk,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/sosi',
      name: 'sosi',
      component: sosi,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/funsiamo',
      name: 'funsiamo',
      component: funsiamo,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/june1',
      name: 'june1',
      component: june1,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/parklane',
      name: 'parklane',
      component: parklane,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/dayung',
      name: 'dayung',
      component: dayung,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/eilis',
      name: 'eilis',
      component: eilis,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/jd',
      name: 'jd',
      component: jd,
      meta: {
        title: '今日訊息'
      }
    },
    {
      path: '/lz',
      name: 'lz',
      component: lz,
      meta: {
        title: '梨子咖啡館'
      }
    },
    {
      path: '/beauty',
      name: 'beauty',
      component: beauty,
      meta: {
        title: 'Beauty美妝生活圈'
      }
    },
    {
      path: '/jdHome',
      name: 'jdHome',
      component: jdHome,
      meta: {
        title: '今日訊息 JINRIH 任務紀錄卡'
      }
    },
    {
      path: '/jdRecommend',
      name: 'jdRecommend',
      component: jdRecommend,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/beautyHome',
      name: 'beautyHome',
      component: beautyHome,
      meta: {
        title: 'Beauty美妝生活圈 任務記錄卡'
      }
    },
    {
      path: '/beautyRecommend',
      name: 'beautyRecommend',
      component: beautyRecommend,
      meta: {
        title: '加入好友看更多'
      }
    },
    {
      path: '/dybossMGMHome',
      name: 'dybossMGMHome',
      component: dybossMGMHome,
      meta: {
        title: '邱老闆鮮果冒險 任務記錄卡'
      }
    },
    {
      path: '/dybossRecommend',
      name: 'dybossRecommend',
      component: dybossRecommend,
      meta: {
        title: '邀請好友一起來玩'
      }
    },
    {
      path: '/dybossRecRecommend',
      name: 'dybossRecRecommend',
      component: dybossRecRecommend,
      meta: {
        title: '接受好友的邀請'
      }
    },
    {
      path: '/markMGMHome',
      name: 'markMGMHome',
      component: markMGMHome,
      meta: {
        title: 'IamMarkVen|馬克凡 任務記錄卡'
      }
    },
    {
      path: '/markRecommend',
      name: 'markRecommend',
      component: markRecommend,
      meta: {
        title: '邀請好友一起來玩'
      }
    },
    {
      path: '/markRecRecommend',
      name: 'markRecRecommend',
      component: markRecRecommend,
      meta: {
        title: '接受好友的邀請'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js